'use strict';

const UserSettingsCtrl = function (CRUDService, config) {
  var ctrl = this;

  var currentPage = 0;
  var totalPages;

  ctrl.$onInit = function() {
      CRUDService.getAll(config.urls.users + '?projection=default').then(function (data){
      ctrl.users = data._embedded.users;
      totalPages = data.page.totalPages;
    });
  };

  ctrl.remove = function(item){
    CRUDService.remove(item._links.self.href).then(
      function(){
        ctrl.$onInit();
      });
  };

  ctrl.getNextPage = function() {
    if ((currentPage + 1) < totalPages) {
      currentPage++;
      CRUDService.getAll(config.urls.users + '?projection=default', currentPage).then(function (data) {
        ctrl.users = ctrl.users.concat(data._embedded.users);
      });
    }
  };
}

UserSettingsCtrl.$inject = ['CRUDService', 'config'];

module.exports = {
  template: require('./users.html'),
  controller: UserSettingsCtrl
};



// WEBPACK FOOTER //
// ./src/main/webapp-files/modules/settings/components/settings-users/settings-users.component.js